import { loginRequest } from './authConfig';
import { configs } from './constants/configs';

export const getLoginScope = () => {
  const scopes = loginRequest(configs.REACT_APP_CLIENT_ID);

  return scopes;
};
